import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { CustomerService } from "../../../../../../services/modules/customer-client.service";
import {RightShipDialogServiceConstants} from "../../../../../../constants/basics/rightship-dialog.constants";

@autoinject()
export class TrialVersionDialog{

    title: string;
    customerId: number;

    constructor(private notificationService: NotificationClientService, private dialogClientService: DialogClientService,
        private customerService: CustomerService) {

    }

    activate(model: {title: string, customerId: number}){
        this.title = model.title;
        this.customerId = model.customerId;
    }

    close() {
        this.dialogClientService.hide();
    }

    async customerRequestFullVersion()
    {
        try {
            await this.customerService.sendBuyFullVersionRequest(this.customerId);

            this.dialogClientService.hide().then(() => {
                this.dialogClientService.show(RightShipDialogServiceConstants.URLs.PurchaseRequestDialog,
                        {
                            title: 'RightShip Sales Team Contacted',
                            description: 'Your request has been sent to the RightShip sales team. You will be contacted shortly.'
                        });
            });
        } catch (e)
        {
            this.notificationService.show("Error!", "Failed to send request to RightShip team", NotificationType.Error);
        }
    }
}
